import React from "react";
import { Box, Grid, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import {
    ListAlt as ECNIcon,
    CalendarMonth as ScheduleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const engineeringItems = [
    {
        title: "ECNs",
        desc: "Engineering Change Notices.",
        path: "/engineering/ecns",
        icon: ECNIcon,
    },
    {
        title: "Engineering Schedule",
        desc: "Track engineer workload and due dates.",
        path: "/engineering/schedule",
        icon: ScheduleIcon,
    },
];

export default function Engineering() {
    const navigate = useNavigate();

    return (
        <Box>
            <Grid container spacing={2}>
                {engineeringItems.map(({ title, desc, path, icon: Icon }) => (
                    <Grid item xs={6} key={path}>
                        <Card
                            sx={{
                                height: "100%",
                                boxShadow: "none",
                                border: 1,
                                borderColor: "primary.main",
                            }}
                        >
                            <CardActionArea
                                onClick={() => navigate(path)}
                                sx={{ height: "100%", alignItems: "flex-start" }}
                            >
                                <CardContent>
                                    <Box sx={{ mb: 1 }}>
                                        <Icon color="primary" fontSize="medium" />
                                    </Box>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 700,
                                            lineHeight: 1.3,
                                            mb: 0.5,
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {desc}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
